'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ChevronRightIcon = ({ sx, className, onClick }) => {
  return (
    <SvgIcon sx={sx} className={className} data-testid="ChevronRightIcon" onClick={onClick || null}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.4482 11.9879C14.4482 12.216 14.3504 12.4115 14.1875 12.5418L10.5383 15.7675C10.2776 15.9956 9.88667 15.963 9.69117 15.7023C9.49567 15.4417 9.49567 15.0832 9.75634 14.8552L12.9494 12.0531C12.982 12.0205 12.982 11.9879 12.9494 11.9228L9.75634 9.12068C9.49567 8.89261 9.49567 8.50161 9.72374 8.27355C9.95184 8.04548 10.3102 8.01288 10.5709 8.20838L14.2201 11.4014C14.3504 11.5644 14.4482 11.7598 14.4482 11.9879Z"
          fill={sx?.color || '#3D517B'}
        />
      </svg>
    </SvgIcon>
  )
}

ChevronRightIcon.propTypes = {
  sx: PropTypes.object,
  className: PropTypes.any,
  onClick: PropTypes.func
}
